export default __webpack_public_path__ + "7a2a0c5d02fdc6ee4b2816e23dd6934c.png";